import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../wayfinder'
/**
* @see \App\Domain\Org\Http\Controllers\AuthController::confirm
* @see app/Domain/Org/Http/Controllers/AuthController.php:72
* @route '//org.launchstation.app/auth/enroll'
*/
export const confirm = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: confirm.url(options),
    method: 'post',
})

confirm.definition = {
    methods: ["post"],
    url: '//org.launchstation.app/auth/enroll',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Domain\Org\Http\Controllers\AuthController::confirm
* @see app/Domain/Org/Http/Controllers/AuthController.php:72
* @route '//org.launchstation.app/auth/enroll'
*/
confirm.url = (options?: RouteQueryOptions) => {
    return confirm.definition.url + queryParams(options)
}

/**
* @see \App\Domain\Org\Http\Controllers\AuthController::confirm
* @see app/Domain/Org/Http/Controllers/AuthController.php:72
* @route '//org.launchstation.app/auth/enroll'
*/
confirm.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: confirm.url(options),
    method: 'post',
})

/**
* @see \App\Domain\Org\Http\Controllers\AuthController::confirm
* @see app/Domain/Org/Http/Controllers/AuthController.php:72
* @route '//org.launchstation.app/auth/enroll'
*/
const confirmForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: confirm.url(options),
    method: 'post',
})

/**
* @see \App\Domain\Org\Http\Controllers\AuthController::confirm
* @see app/Domain/Org/Http/Controllers/AuthController.php:72
* @route '//org.launchstation.app/auth/enroll'
*/
confirmForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: confirm.url(options),
    method: 'post',
})

confirm.form = confirmForm

const enroll = {
    confirm: Object.assign(confirm, confirm),
}

export default enroll